<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="referrals-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Polecenia kierowców</h1>
      </div>
    </div>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="referrals"
          class="elevation-1"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
        >
          <template v-slot:top>
            <div class="table-section-title">
              <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-account-multiple-plus</v-icon></div>
              <div class="filter-title">{{ $t('pointsReferrals.title') }}</div>
            </div>
          </template>
          <template v-slot:item.referrer="{ item }">
            <div>
              <strong>{{ item.referrerName }}</strong>
              <br />
              <span class="grey--text text--darken-1">{{ item.referrerCode }}</span>
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <div v-if="item.pointsStatus === 'AWARDED'">
              <v-chip color="green" dark small>{{ $t('pointsReferrals.awarded') }}</v-chip>
              <br />
              <span class="caption grey--text">{{ item.awardedAt }}</span>
            </div>
            <div v-else>
              <v-chip color="orange" dark small>{{ $t('pointsReferrals.pendingStatus') }}</v-chip>
              <v-progress-linear
                v-if="item.progress !== undefined && item.progress !== null"
                :value="item.progress"
                class="mt-1"
                height="6"
                rounded
              ></v-progress-linear>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      loading: false,
      referrals: [],
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 20,
      },
      headers: [
        { text: "Polecajacy", value: "referrer", sortable: false },
        { text: "Polecony", value: "referredName", sortable: false },
        { text: "Data rejestracji", value: "registrationDate", sortable: false },
        { text: "Status punktow", value: "status", sortable: false },
      ],
    };
  },
  async created() {
    await this.initialize();
  },
  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  methods: {
    getAuthHeaders() {
      return {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
    },
    async initialize() {
      this.loading = true;
      try {
        const take = this.options.itemsPerPage;
        const skip = (this.options.page - 1) * take;
        const res = await axios({
          method: "get",
          url:
            process.env.VUE_APP_ROOT_API +
            `points/admin/referrals?take=${take}&skip=${skip}`,
          headers: this.getAuthHeaders(),
        });
        const data = res.data.data || res.data;
        const result = data.result || data.items || data;
        this.totalItems = data.count || data.total || result.length;
        this.referrals = (Array.isArray(result) ? result : []).map((item) => {
          return {
            referrerName: item.referrerName || (item.referrer ? item.referrer.firstName + " " + item.referrer.lastName : "-"),
            referrerCode: item.referrerCode || (item.referrer ? item.referrer.code : "-"),
            referredName: item.referredName || (item.referred ? item.referred.firstName + " " + item.referred.lastName : "-"),
            registrationDate: item.registrationDate
              ? dayjs(item.registrationDate).format("DD-MM-YYYY")
              : "-",
            pointsStatus: item.pointsStatus || item.status || "PENDING",
            awardedAt: item.awardedAt
              ? dayjs(item.awardedAt).format("DD-MM-YYYY")
              : null,
            progress: item.progress != null ? item.progress : null,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire(
          "Blad",
          e.response?.data?.message?.toString() || "Wystapil blad",
          "error"
        );
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.referrals-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; letter-spacing: -0.01em; flex-grow: 1; }

.referrals-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.referrals-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.referrals-page >>> .v-data-table tbody tr { background: #232838 !important; }
.referrals-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.referrals-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.referrals-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.referrals-page >>> .grey--text { color: #B0BEC5 !important; }
.referrals-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.referrals-page >>> .v-chip.green { background: rgba(45,203,115,0.18) !important; color: #6FE89A !important; }
.referrals-page >>> .v-chip.orange { background: rgba(255,152,0,0.18) !important; color: #FFB74D !important; }
.referrals-page >>> .v-progress-linear { background: rgba(255,255,255,0.08) !important; }
</style>
